



















































































































































































































































































































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import store from "@/services/store";
import { loadUserLevels } from "../budget/budgetVariantService";
import {genListOfYears} from "@/modules/budget/budgetCorrectHelper";
import {IEbkItem} from "@/modules/user-management/user-management-int";
import {BDropdown, BIconSearch, BTable, BIcon, BIconXCircle} from "bootstrap-vue";
import {
    TransfertGroup,
    ProjectCheckerData,
    FundingSource,
    TransferData,
    IDict,
    applyFilters,
    dict_transfert_group,
    TransferRegion,
    TransferSaveData,
    ProjectFromBank, KbkCode, TransferSources, KbkData,
} from "@/modules/transfert/TransferTypes";
import TransferAddModal from "./TransferAddModal.vue";
import TransferKbkAddModal from "./TransferKbkAddModal.vue";
import TransferRelationsModal, { RelationResult } from "./TransferRelationsModal.vue";
import {Ax} from '@/utils';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect';

@Component({
    components: {
        BIconSearch,
        TransferAddModal,
        TransferKbkAddModal,
        TransferRelationsModal,
        BIcon,
        BIconXCircle,
        'loading': VueElementLoading,
        'multiselect': Multiselect,
    },
})
export default class Transfert extends Vue {
    async created() {
        await this.getUserLevels();
        if (![1, 2, 3].includes(this.accessLevel)) {
            this.availableForUser = false
            this.makeToast('danger', this.$t('modules.transfert.toasts.no_access') as string, this.$t('modules.transfert.toasts.message_title') as string)
            return
        }
    }

    private mounted_data = false;

    async mounted() {
        await this.loadUserType();
        await this.setUserBudgetLevel();
        await this.loadRegions();
        await this.loadDirection();
        await this.load_cur_year();
        await this.loadTransfers();
    }

    get userUiid() {
        return store.state.user.sub;
    }

    loading = false;

    availableForUser = true;

    $refs!: {
        transferAddRef: TransferAddModal;
        transferKbkAddRef: TransferKbkAddModal;
        drop: BDropdown;
        myTable: BTable;
    };

    get dict_transfer_group() {
        return dict_transfert_group().map(group => ({
            ...group,
            name_ru: this.$t('modules.transfert.groups.' + group.code) as string,
        }));
    }

    @Watch("regionFilter")
    async onChangeRegionFilter(value: string, oldValue: string) {
        localStorage[this.lsRegionFilter] = value;
        console.debug("onChangeRegionFilter 1", this.mounted_data);
        if (this.mounted_data) { await this.loadTransfers() };
        console.debug("onChangeRegionFilter 2");
        this.selectedProject = null;
    }

    @Watch("transferGroupFilter")
    async onChangeTransferGroupFilter(value: string, oldValue: string) {
        localStorage[this.lsTransferGroupFilter] = value;
        console.debug("onChangeTransferGroupFilter 1", this.mounted_data);
        // await this.loadTransfers();
        if (this.mounted_data) { await this.loadTransfers() };
        console.debug("onChangeTransferGroupFilter 2");
        this.selectedProject = null;
    }

    @Watch("directionFilter")
    onChangedirectionFilter(value: string, oldValue: string) {
        localStorage[this.lsDirectionFilter] = value;
    }

    @Watch("cur_year")
    async onChangeYearFilter(value: number, oldValue: number) {
        localStorage[this.lsYearFilter] = value;
        console.debug("onChangeYearFilter 1", this.mounted_data);
        // await this.loadTransfers();
        if (this.mounted_data) { await this.loadTransfers() };
        console.debug("onChangeYearFilter 2");
    }

    openFilterByRef(refName: string) {
        const drop: any = this.$refs.drop;
        drop.show(true);
    }

    accessLevel: number = 0

    async getUserLevels() {
        if (this.userUiid) {
            let response: any = [];
            try {
                await loadUserLevels(this.userUiid).then(data => {
                    response = data;
                });
                for (const row of response) {
                    switch (row.modules) {
                        case "003.007":
                            this.accessLevel = row.access_level;
                            break;
                            default:
                                break;
                    }
                }
            } catch (error) {
                this.makeToast("danger", this.$t('modules.transfert.toasts.error_get_user_levels') as string, error instanceof Error ? error.message : String(error));
            }
        }
    }

    get isItemDisabled() {
        const levelAccessToEdit = [2, 3];
        return !levelAccessToEdit.includes(this.accessLevel);
    }

    clickTransfer(item: TransferData, index: number, event: any) {
        console.debug("Start click")
        if (this.selectedProject === item) {
            console.debug("Start 1");
            this.selectedProject = null;
        } else {
            this.selectedProject = item;
            console.debug("Start 2", this.selectedProject.kbk_data);
            if (!this.selectedProject.kbk_data.has(this.regionFilter)) {
                console.debug("Start selectedProject");
                this.selectedProject.kbk_data.set(this.regionFilter, [])
                console.debug("Stop selectedProject");
            }
            console.debug("Start check");
            this.checkDeleteConditions(item)
            console.debug("Stop check");
        }
        console.debug("Stop click")
    }

    getRegion(regCode: string) {
        const res = this.regionList.find((value: any) => value.code == regCode);
        if (res) {
            return res;
        } else {
            return {
                name_ru: this.$t('modules.transfert.not_selected') as string,
            };
        }
    }

    regionDisplayName(reg: { name_ru: string; name_kk?: string }): string {
        return this.$i18n.locale === 'kk' && reg.name_kk ? reg.name_kk : reg.name_ru;
    }

    regionLabel(reg: IDict): string {
        const name = this.regionDisplayName(reg);
        return reg.code != null ? reg.code + "-" + name : name;
    }

    get selectedRegionOption(): IDict | null {
        return this.regionList.find((reg) => reg.code === this.regionFilter) || null;
    }

    set selectedRegionOption(value: IDict | null) {
        this.regionFilter = value ? value.code : "";
    }

    getFgr(regCode: string) {
        const res = this.dict_transfer_group.find((value: any) => value.code == regCode);
        if (res) {
            return res;
        } else {
            return {
                name_ru: this.$t('modules.transfert.not_selected') as string,
            };
        }
    }

    transfer_add() {
        this.$bvModal.show("transfer_add_modal");
    }

    // Обработчик события показа модального окна - ленивая загрузка проектов
    async onTransferModalShow() {
        const transferAddRef = this.$refs.transferAddRef as TransferAddModal;
        if (transferAddRef && transferAddRef.ensureProjectsLoaded) {
            await transferAddRef.ensureProjectsLoaded();
        }
    }

    modalSource: TransferSources = {
        funding_source: "01",
        budget_level: "01"
    }

    modalKbk: KbkCode = {abp: 0, ppr: 0, prg: 0};
    modalReusable: boolean = false;
    // Режим окна выбора КБК: single - клетка с одним КБК, add/edit - клетка КБК (ОБ)/(Район) с несколькими КБК
    modalMode: 'single' | 'add' | 'edit' = 'single';
    modalContext: string = '';
    modalOthers: string[] = [];
    // Изменяемый КБК (для дубля исключаем сам изменяемый КБК)
    modalTarget: KbkData | null = null;
    // Счётчик для перерисовки клеток (kbk_data - Map, Vue 2 его не отслеживает)
    kbkTick = 0;

    @Watch("modalKbk")
    onChangeModalKbk(value: string, oldValue: string) {
    }


    makeToast(variant: string, tostbody: string, title: string) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            autoHideDelay: 4000,
            solid: true,
            appendToast: true,
        });
    }

    hide() {
        (this.$refs.drop as BDropdown).hide(true);
    }

    cur_year = new Date().getFullYear();

    load_cur_year() {
        if (localStorage[this.lsYearFilter]) {
            this.cur_year = Number(localStorage[this.lsYearFilter]);
        } else {
            this.cur_year = new Date().getFullYear();
        }
    }

    get listOfYears() {
        return genListOfYears();
    }

    regionList: IDict[] = [];
    regionBase: IDict[] = [];
    regionFilter = "";
    lsRegionFilter = "transfert_region";
    transferGroupFilter = null;
    lsTransferGroupFilter = "transfert_group";
    lsDirectionFilter = "transfert_Direction";
    lsYearFilter = "transfert_year";
    userBudgetLevel: string = "";
    isLead: boolean = false;

    private async setUserBudgetLevel() {
        const response = await fetch("/api-py/get-user-budget-level-transfert/" + this.userUiid);
        this.userBudgetLevel = await response.json()
        return this.userBudgetLevel
    }

    private async loadUserType() {
        const response = await fetch("/api-py/get-user-budget-level-transfert-if-lead/" + this.userUiid);
        this.isLead = await response.json()
    }

    private async loadRegions() {
        const code: string = this.$store.state._instanceCode;
        let region = {
            obl: "45",
        };
        await fetch("/api-py/get-budget-obl/" + code)
            .then((response) => response.json())
            .then((json) => {
                region = json;
            });
        try {
            const response = await fetch(
                "/api-py/get-user-regions-by-obl/" +
                region.obl +
                "/" +
                this.$store.getters.user_uuid
            );
            this.regionBase = (await response.json()) as IDict[];
            this.regionList = [...this.regionBase];
            if (localStorage[this.lsRegionFilter]) {
                this.regionFilter = localStorage[this.lsRegionFilter];
            } else if (this.regionList[0]) {
                this.regionFilter = this.regionList[0].code;
            }
        } catch (error) {
            this.makeToast(
                "danger",
                this.$t('modules.transfert.toasts.error_load_regions') as string,
                error instanceof Error ? error.message : String(error)
            );
        }
    }

    funcGrBase: any = [];
    directionList: any[] = [];
    directionFilter = "";

    private directionMap = new Map<string, { name_ru: string; name_kk?: string }>();

    directionDisplayName(reg: { name_ru?: string; name_kk?: string } | null | undefined): string {
        if (!reg) return this.$t('modules.transfert.no_direction_code') as string;
        return this.$i18n.locale === 'kk' && reg.name_kk ? reg.name_kk : (reg.name_ru ?? '');
    }

    private async loadDirection() {
        try {
            const response = await fetch("/api-py/get-dict-func-childs-by-parent/0");
            this.funcGrBase = (await response.json()) as IEbkItem;
            this.directionList = [...this.funcGrBase];

            // Индекс для быстрого поиска
            this.directionMap = new Map(
                this.directionList.map(item => [item.gr, { name_ru: item.name_ru, name_kk: item.name_kk }])
            );

            if (localStorage[this.lsDirectionFilter]) {
                this.directionFilter = localStorage[this.lsDirectionFilter];
            } else if (this.directionList[0]) {
                this.directionFilter = this.directionList[0].code;
            }
        } catch (error) {
            this.makeToast(
                "danger",
                this.$t('modules.transfert.toasts.error_load_func_groups') as string,
                error instanceof Error ? error.message : String(error)
            );
        }
    }

    private async loadDirection_old() {
        try {
            const response = await fetch("/api-py/get-dict-func-childs-by-parent/0");
            this.funcGrBase = (await response.json()) as IEbkItem;
            this.directionList = [...this.funcGrBase];
            if (localStorage[this.lsDirectionFilter]) {
                this.directionFilter = localStorage[this.lsDirectionFilter];
            } else if (this.directionList[0]) {
                this.directionFilter = this.directionList[0].code;
            }
        } catch (error) {
            this.makeToast(
                "danger",
                this.$t('modules.transfert.toasts.error_load_func_groups') as string,
                error instanceof Error ? error.message : String(error)
            );
        }
    }

    get register_of_expense_items_table_field() {
        return [
        {
            key: "transfer_group",
            label: this.$t('modules.transfert.group') as string,
            sortable: true,
            thStyle: {width: "10px", minWidth: "10px", maxWidth: "10px", whiteSpace: "nowrap"}
        },
        {
            key: "expense_code",
            label: this.$t('modules.transfert.code') as string,
            sortable: false,
            sortByFormatted: true,
            thStyle: {width: "150px", minWidth: "160px", maxWidth: "200px"},
            formatter: (value: any, key: any, item: TransferData) =>
                this.formatCode(value, key, item),
            sortCompare: (a: any, b: any, rowA: TransferData, rowB: TransferData) => {
                const codeA = this.formatCode(a, "expense_code", rowA);
                const codeB = this.formatCode(b, "expense_code", rowB);
                return codeA.localeCompare(codeB, undefined, { numeric: true, sensitivity: "base" });
            }
        },
        {
            key: "name",
            label: this.$t('modules.transfert.name') as string,
            sortable: false,
            sortByFormatted: true,
            thStyle: {width: "200px"},
            formatter: (value: any, key: any, item: TransferData) =>
                this.formatName(value, key, item),
        },
        {
            key: "direction",
            label: this.$t('modules.transfert.direction') as string,
            sortable: true,
            thStyle: {width: "200px"},
            formatter: (value: any, key: any, item: TransferData) =>
                this.formatDirection(value), //, key, item),
        },
        {
            key: "period",
            label: this.$t('modules.transfert.period') as string,
            sortable: true,
            thStyle: {width: "5px"},
            formatter: (value: any, key: any, item: TransferData) =>
                this.formatPeriod(value, key, item),
        },
        {
            key: "status",
            label: this.$t('modules.transfert.status') as string,
            thStyle: {width: "100px"},
            formatter: (value: any, key: any, item: TransferData) =>
                this.calcStatus(item),
        },
        {
            key: 'actions',
            label: '',
            thStyle: {width: "1px"},
        },
        ];
    }

    private calcStatus(item: TransferData): string {
        if (item.project_from_bank?.is_archive) {
            return this.$t('modules.transfert.status_archived') as string;
        }

        const kbkData = item.kbk_data.get(this.regionFilter);

        if (!kbkData) {
            return this.$t('modules.transfert.status_no_kbk') as string;
        }

        return kbkData.some(
            x => x.kbk_code.abp !== 0 && x.kbk_code.prg !== 0
        )
            ? this.$t('modules.transfert.status_filled') as string
            : this.$t('modules.transfert.status_not_filled') as string;
    }

    formatStatus(value: any, key: string, item: TransferData): string {
        if (item.project_from_bank?.is_archive == true) return this.$t('modules.transfert.status_archived') as string;
        if (item) {
            if (item.kbk_data.has(this.regionFilter)) {
                const kbk_data = item.kbk_data.get(this.regionFilter)
                if (kbk_data) {
                    for (const kbkDatum of kbk_data) {
                        if ((kbkDatum.kbk_code.abp != 0) && (kbkDatum.kbk_code.prg != 0)) {
                            return this.$t('modules.transfert.status_filled') as string;
                        }
                    }
                } else {
                    return this.$t('modules.transfert.status_no_kbk') as string
                }
            } else {
                return this.$t('modules.transfert.status_no_kbk') as string
            }
        } else {
            return this.$t('modules.transfert.status_not_filled') as string;
        }
        return "....."
    }

    formatName(value: any, key: string, item: TransferData): string {
        if (!item?.project_from_bank?.code) {
            return this.$t('modules.transfert.no_project_name') as string;
        }

        const code = item.project_from_bank.code;
        const project = this.projectMap.get(code);

        // Если проекта нет в кеше - запускаем фоновую загрузку
        if (!project) {
            this.loadProjectByCode(code); // Асинхронная загрузка в фоне (без await)
            return this.loadingProjects.has(code) ? this.$t('modules.transfert.loading_dots') as string : this.$t('modules.transfert.no_project_name') as string;
        }

        return project.name_ru || this.$t('modules.transfert.no_project_name') as string;
    }

    formatCode(value: any, key: string, item: TransferData): string {
        if (!item?.project_from_bank?.code) {
            return this.$t('modules.transfert.no_project_code') as string;
        }
        return item.project_from_bank.code;
        // return this.projectMap.get(item.project_from_bank.code)?.code || "Нет кода в проектах"
    }

    formatPeriod(value: any, key: string, item: TransferData): string {
        if (!item?.project_from_bank?.code) {
            return this.$t('modules.transfert.no_project_code') as string;
        }

        const code = item.project_from_bank.code;
        const project = this.projectMap.get(code);

        // Если проекта нет в кеше - запускаем фоновую загрузку
        if (!project) {
            this.loadProjectByCode(code); // Асинхронная загрузка в фоне (без await)
            return this.loadingProjects.has(code) ? this.$t('modules.transfert.loading_dots') as string : this.$t('modules.transfert.no_project_code') as string;
        }

        const begin = new Date(project.begin_date);
        const end = new Date(project.end_date);

        const beginYear = isNaN(begin.getTime()) ? "???" : begin.getFullYear();
        const endYear = isNaN(end.getTime()) ? "???" : end.getFullYear();

        return `${beginYear} - ${endYear}`;
    }

    formatDirection(value: string): string {
        return this.directionDisplayName(this.directionMap.get(value));
    }

    formatDirection_old(value: any, key: string, item: TransferData): string {
        return this.directionDisplayName(this.directionList.find((value1) => value1.gr == value));
    }

    clearedRows: TransferSaveData[] = [];
    deletedRows: TransferSaveData[] = [];
    private deletedBackup = new Map<string, KbkData[]>();

    get sources_of_financing_fields() {
        return [
        {
            key: "code_funding_level",
            label: this.$t('modules.transfert.funding_level') as string,
            formatter: (value: any, key: any, item: TransferData) =>
                this.formaterFundingLevel(value, key, item),
            thStyle: {width: "150px"},
        },
        {
            key: "code_1_level",
            label: this.$t('modules.transfert.kbk_national_fund') as string,
            thStyle: {width: "90px"},
        },
        {key: "code_2_level", label: this.$t('modules.transfert.kbk_republican') as string, thStyle: {width: "90px"}},
        {key: "code_3_level", label: this.$t('modules.transfert.kbk_oblast') as string, thStyle: {width: "90px"}},
        {key: "code_4_level", label: this.$t('modules.transfert.kbk_district') as string, thStyle: {width: "90px"}},
        {key: "code_5_level", label: this.$t('modules.transfert.kbk_msu') as string, thStyle: {width: "90px"}},
        ];
    }

    get filteredSourcesFields() {
        const regionLevel = this.get_region_level(this.regionFilter);

        return this.sources_of_financing_fields.map(field => {
            const allowedKeys = {
                "03": ["code_1_level", "code_2_level", "code_3_level"], // Область
                "04": ["code_4_level"], // Район
                "05": ["code_5_level"] // МСУ
            };
            const levelCodeMatch = field.key.match(/^code_(\d)_level$/);
            const fieldLevelCode = levelCodeMatch ? `0${levelCodeMatch[1]}` : null;

            return {
                ...field,
                disabled: !allowedKeys[regionLevel]?.includes(field.key),
                tdClass: (value: any, key: any, item: any) => {
                    if (!fieldLevelCode) return '';
                    return !this.isFieldEditable(fieldLevelCode, item.code_funding_level)
                        ? 'cell-disabled'
                        : '';
                }
            };
        });
    }

    isFieldEditable(level: string, funding_source: string): boolean {
        if (!this.regionFilter.endsWith("0101") && ["01", "02"].includes(level)) {
            return false;
        }
        const regionLevel = this.get_region_level(this.regionFilter);
        if (regionLevel === "03") {
            return (
                (level === "01" && funding_source === "01") ||
                (level === "02" && funding_source === "02") ||
                (level === "03" && ["01", "02", "03"].includes(funding_source))
            );
        }
        if (regionLevel === "04") {
            return level === "04" && funding_source !== "05";
        }
        if (regionLevel === "05") {
            return level === "05";
        }

        return false;
    }

    formaterFundingLevel(value: any, key: string, item: any): string {
        const fund = this.funding_level.find((fl) => fl.code == value);
        if (fund) return value + " - " + fund.name_ru;
        return value + " test" + key;
    }

    get funding_level() {
        return [
        {code: "01", name_ru: this.$t('modules.transfert.funding_levels.01') as string},
        {code: "02", name_ru: this.$t('modules.transfert.funding_levels.02') as string},
        {code: "03", name_ru: this.$t('modules.transfert.funding_levels.03') as string},
        {code: "04", name_ru: this.$t('modules.transfert.funding_levels.04') as string},
        {code: "05", name_ru: this.$t('modules.transfert.funding_levels.05') as string},
        ];
    }

    get funding_table_items(): FundingSource[] {
        const result: FundingSource[] = [];
        for (const fl of this.funding_level) {
            const item: FundingSource = {
                code_funding_level: fl.code,
                code_1_level: "",
                code_2_level: "",
                code_3_level: "",
                code_4_level: "",
                code_5_level: "",
            };
            result.push(item);
        }
        return result;
    }

    private projectMap: Map<string, ProjectFromBank> = new Map();
    // Кеш загружающихся проектов (предотвращает дублирующиеся запросы)
    private loadingProjects: Set<string> = new Set();

    // Ленивая загрузка проекта по коду (вызывается из форматеров)
    private async loadProjectByCode(code: string): Promise<void> {
        // Если проект уже загружается или загружен - пропускаем
        if (this.loadingProjects.has(code) || this.projectMap.has(code)) {
            return;
        }

        this.loadingProjects.add(code);

        try {
            const response = await fetch(`/api-py/get-transfert-projects-by-code/${code}`);
            if (response.ok) {
                const projects = await response.json() as ProjectFromBank[];
                // Endpoint возвращает массив - берем первый элемент
                if (projects && projects.length > 0) {
                    this.projectMap.set(code, projects[0]);
                    // Vue 2 не отслеживает изменения в Map — принудительно обновляем компонент
                    this.$forceUpdate();
                }
            }
        } catch (error) {
            console.warn(`Не удалось загрузить проект ${code}:`, error);
        } finally {
            this.loadingProjects.delete(code);
        }
    }

    // Инициализация (вызвать один раз при загрузке данных)
    initProjectMap(): void {
        this.projectMap = new Map(
            this.modalProjectList.map(project => [project.code, project])
        );
    }

    modalProjectListUpdated(projects: ProjectFromBank[]) {
        console.debug("start modalProjectListUpdated")
        this.modalProjectList = projects;
        this.initProjectMap();
        console.debug("stop modalProjectListUpdated")
    }

    modalProjectList: ProjectFromBank[] = [];

    get regionForTransferList(): TransferRegion[] {
        const result: TransferRegion[] = [];
        for (const region of this.regionsForFunding) {
            const tr_region: TransferRegion = {
                checked: region.code == this.regionFilter,
                region: region,
                disabled: false
            };
            let list_of_region: string[] = [];
            const projectInRegion = this.transfertList.some(project => {
                if (project.project_from_bank?.code !== this.selectedProject?.project_from_bank?.code) {
                    return false;
                }
                const kbkEntries = project.kbk_data.get(region.code);
                return kbkEntries && kbkEntries.length > 0;
            });
            if (projectInRegion) {
                tr_region.checked = true;
            }
            if (this.selectedProject) {
                list_of_region = Array.from(this.selectedProject.kbk_data.keys());
            }
            if (list_of_region?.includes(tr_region.region.code)) {
                tr_region.checked = true;
                if (this.selectedProject) {
                    const kbk_entries = this.selectedProject.kbk_data.get(tr_region.region.code);
                    if (kbk_entries?.some(kbk => Object.values(kbk.kbk_code).some(val => val !== 0))) {
                        tr_region.disabled = true;
                    }
                }
            }
            if (this.regionFilter.endsWith("0101") && tr_region.region.code.match(/^\d{4}01$/)) {
                const regionPrefix = tr_region.region.code.slice(0, 4);
                if (list_of_region.some(kbk_code => kbk_code.startsWith(regionPrefix) && !kbk_code.endsWith("01"))) {
                    tr_region.disabled = true;
                }
            }
            result.push(tr_region);
        }

        return result;
    }

    async updateRegionSelection(projectCode: string, regionCode: string, isChecked: boolean) {
        const project = this.transfertList.find(
            p => p.project_from_bank.code === projectCode && p.kbk_data.has(this.regionFilter)
        );
        if (!project) return;
        if (isChecked) {
            if (!project.kbk_data.has(regionCode)) {
                project.kbk_data.set(regionCode, [{
                    kbk_code: { abp: 0, prg: 0, ppr: 0 },
                    transfer_sources: {
                        funding_source: this.get_transfer_funding_source(project),
                        budget_level: this.get_region_level(regionCode)
                    }
                }]);
            }
            this.deletedRows = this.deletedRows.filter(row => row.region !== regionCode);
            this.deletedBackup.delete(`${projectCode}|${regionCode}`);
        } else {
            const kbkEntry = project.kbk_data.get(regionCode);
            if (!kbkEntry) return;

            try {
                const kbkCombos: Array<{ abp: number; prg: number; ppr: number | null }> = [];
                const seenKbk = new Set<string>();
                for (const [, kbkList] of project.kbk_data) {
                    for (const kbk of kbkList.filter(k => k.kbk_code.abp !== 0 || k.kbk_code.prg !== 0)) {
                        const key = `${kbk.kbk_code.abp}|${kbk.kbk_code.prg ?? 0}|${kbk.kbk_code.ppr ?? 0}`;
                        if (!seenKbk.has(key)) {
                            seenKbk.add(key);
                            kbkCombos.push({ abp: kbk.kbk_code.abp, prg: kbk.kbk_code.prg ?? 0, ppr: kbk.kbk_code.ppr ?? null });
                        }
                    }
                }
                if (kbkCombos.length === 0) {
                    kbkCombos.push({ abp: 0, prg: 0, ppr: null });
                }
                const responses = await Promise.all(
                    kbkCombos.map(kbk => {
                        const pprParam = kbk.ppr != null ? `&ppr=${kbk.ppr}` : '';
                        return fetch(`/api-py/check-relations?year=${this.cur_year}&expense_code=${projectCode}&abp=${kbk.abp}&prg=${kbk.prg}${pprParam}`)
                            .then(r => r.json() as Promise<RelationResult[]>);
                    })
                );
                const relevantResults: RelationResult[] = [];
                for (const r of responses.flat()) {
                    if (r.action !== 'block') continue;
                    if (r.source !== 'bp' && r.source !== 'bip') continue;
                    const filteredData = r.data.filter(item => item.region_code === regionCode);
                    if (filteredData.length === 0) continue;
                    const seen = new Set<string>();
                    relevantResults.push({
                        ...r,
                        data: filteredData.filter(item => {
                            const key = `${item.code}|${item.variant}|${item.gu}|${item.year}`;
                            if (seen.has(key)) return false;
                            seen.add(key);
                            return true;
                        })
                    });
                }
                if (relevantResults.length > 0) {
                    this.relationsModalTitle = this.$t('modules.transfert.toasts.cannot_cancel_region_related') as string;
                    this.relationsCheckResults = relevantResults;
                    this.$bvModal.show('transfer-relations-modal');
                    this.$forceUpdate();
                    await this.$nextTick();
                    this.transfertList = [...this.transfertList];
                    return;
                }
            } catch { /* продолжаем даже если проверка недоступна */ }

            const hasLower = this.hasLowerLevels(project, {
                expense_code: project.project_from_bank.code,
                direction: project.direction,
                transfer_group: project.transfer_group ?? null,
                funding_source: this.get_transfer_funding_source(project),
                budget_level: this.get_region_level(regionCode),
                region: regionCode,
                year: this.cur_year,
                user_id: this.$store.getters.user_uuid
            });

            if (hasLower) {
                this.makeToast(
                    "danger",
                    this.$t('modules.transfert.toasts.cannot_cancel_region_lower_distribution') as string,
                    this.$t('modules.transfert.toasts.error_title') as string
                );
                return;
            }
            if (!this.deletedRows.some(row => row.region === regionCode && row.expense_code === projectCode)) {
                this.deletedBackup.set(`${projectCode}|${regionCode}`, kbkEntry);
                this.deletedRows.push({
                    expense_code: project.project_from_bank.code,
                    direction: project.direction,
                    transfer_group: project.transfer_group,
                    funding_source: kbkEntry[0]?.transfer_sources.funding_source,
                    budget_level: kbkEntry[0]?.transfer_sources.budget_level,
                    region: regionCode,
                    year: this.cur_year,
                    user_id: this.$store.getters.user_uuid,
                    whole_region: true
                });
            }
            project.kbk_data.delete(regionCode);
        }
        this.$forceUpdate();
    }

    get regionsForFunding() {
        const regionCode = this.regionFilter;

        if (regionCode.endsWith("0101")) {
            const regionPrefix = regionCode.substring(0, 2);
            return this.regionList.filter(
                (value) =>
                    value.code.startsWith(regionPrefix) &&
                    (value.code.endsWith("0101") ||
                        (value.code.endsWith("01") &&
                            !value.code.endsWith("0101") &&
                            !value.code.endsWith("00")))
            );
        }

        const regionPart = regionCode.substring(0, 4);

        if (regionCode.endsWith("01")) {
            return this.regionList.filter(
                (value) =>
                    value.code.startsWith(regionPart) &&
                    (value.code.endsWith("01") ||
                        (!value.code.endsWith("00") && !value.code.endsWith("01")))
            );
        }

        return this.regionList.filter((value) => value.code === regionCode);
    }


    addSelectedProjects(selectList: ProjectCheckerData[]) {
        const select_project = selectList.filter((value) => value.checked);
        this.selectedProject = null;
        for (const mtd of select_project) {
            const kbk_data = new Map<string, KbkData[]>();
            const projectRegions = this.regionForTransferList;
            for (const transferRegion of projectRegions) {
                if (transferRegion.checked === true) {
                    const kbk_code: KbkCode = {
                        abp: 0,
                        prg: 0,
                        ppr: 0,
                    };
                    const kbk_source: TransferSources = {
                        funding_source: this.get_transfer_funding_source(this.selectedProject),
                        budget_level: this.get_region_level(transferRegion.region.code)
                    };
                    const existingKbkData = kbk_data.get(transferRegion.region.code) || [];
                    existingKbkData.push({
                        kbk_code: kbk_code,
                        transfer_sources: kbk_source
                    });
                    kbk_data.set(transferRegion.region.code, existingKbkData);
                }
            }
            const trn: TransferData = {
                checked: mtd.checked,
                transfer_group: mtd.transfer_group,
                transfer_group_list: mtd.transfer_group_list,
                direction: "",
                year: this.cur_year,
                project_from_bank: mtd.project_from_bank,
                kbk_data: kbk_data
            };
            trn.status = this.calcStatus(trn);
            const foundItem = this.transfertList.find(
                (value) =>
                    value.project_from_bank.code === mtd.project_from_bank.code &&
                    value.project_from_bank.budget_region === this.regionFilter && Array.from(value.kbk_data.keys()).includes(this.regionFilter)
            );
            if (!foundItem) {
                this.transfertList.unshift(trn);
            }
        }
        this.applyFilters();
    }

    transfertList: TransferData[] = [];

    filter_temp = {
        expense_code: '',
        name: ''
    }

    set_filter () {
        this.filter= {
            expense_code: this.filter_temp.expense_code.trim(),
            name: this.filter_temp.name.trim()
        }
        this.applyFilters();
    }

    clear_filter () {
        this.filter= {
            expense_code: '',
            name: ''
        }
        this.filter_temp= {
            expense_code: '',
            name: ''
        }
        this.applyFilters();
    }

    filter = {
        expense_code: '',
        name: ''
    };

    busy_data = false;
    perPage = 10;
    currentPage = 0;

    filteredTransfers: TransferData[] = [];
    private applyFilters() {
        const expenseCode = this.filter.expense_code?.toLowerCase();
        const name = this.filter.name?.toLowerCase();

        this.filteredTransfers = this.transfertList.filter(item => {
            if (
                expenseCode &&
                !item.project_from_bank?.code?.toLowerCase().includes(expenseCode)
            ) {
                return false;
            }

            if (
                name &&
                !item.project_from_bank?.name_ru?.toLowerCase().includes(name)
            ) {
                return false;
            }

            return true;
        });
    }


    get transfertListFilter(): TransferData[] {
        const expenseCode = this.filter.expense_code?.toLowerCase();
        const name = this.filter.name?.toLowerCase();

        return this.transfertList.filter(item =>
            (!expenseCode ||
                item.project_from_bank.code?.toLowerCase().includes(expenseCode)) &&
            (!name ||
                item.project_from_bank.name_ru?.toLowerCase().includes(name))
        );
    }

    get transfertListFilter_old1(): TransferData[] {
        const expenseCode = this.filter.expense_code?.toLowerCase();
        const name = this.filter.name?.toLowerCase();
        try {
        return this.transfertList.filter(value => {
            if (
                expenseCode &&
                !value.project_from_bank.code?.toLowerCase().includes(expenseCode)
            ) {
                return false;
            }

            if (
                name &&
                !value.project_from_bank.name_ru?.toLowerCase().includes(name)
            ) {
                return false;
            }

            return true;
        });
        } finally {
            this.loading = false;
        }
    }

    get transfertListFilter_old(): TransferData[] {
        console.debug("Start transfertListFilter");
         this.busy_data = true;
        // let result = this.transfertList.filter(value => Array.from(value.kbk_data.keys()).includes(this.regionFilter));
        let result = this.transfertList.filter(value =>
            value.kbk_data.has(this.regionFilter)
        );
        console.debug("Start transfertListFilter-1");
        if (this.transferGroupFilter) {
            result = result.filter(value => value.transfer_group === this.transferGroupFilter);
        }
        console.debug("Start transfertListFilter-2");
        if (this.filter.expense_code) {
            result = result.filter(value =>
                value.project_from_bank.code?.toLowerCase().includes(this.filter.expense_code.toLowerCase())
            );
        }

        console.debug("Start transfertListFilter-3");
        if (this.filter.name) {
            result = result.filter(value =>
                value.project_from_bank.name_ru?.toLowerCase().includes(this.filter.name.toLowerCase())
            );
        }
        console.debug("Stop transfertListFilter");
        this.busy_data = false;
        return result
    }

    get transferGroupBreadcrumb(): string {
        const group = this.transferGroupFilter;
        const filtered = this.transfertListFilter;
        const count = filtered.length;

        if (!group) {
            return `${this.$t('modules.transfert.all')} (${count})`;
        }

        const name = this.getFgr(group)?.name_ru ?? "";
        return `${group} - ${name} (${count})`;
    }


    get_transfer_funding_source(transfer: TransferData | null) {
        let result = "05";
        if (transfer != null) {
            const kbk_data = transfer.kbk_data;
            if (kbk_data) {
                for (const key of kbk_data.keys()) {
                    const trans_source = kbk_data.get(key);
                    if (trans_source) {
                        for (const kbkDatum of trans_source) {
                            if (kbkDatum.transfer_sources.funding_source < result) {
                                result = kbkDatum.transfer_sources.funding_source
                            }
                        }
                    }
                }
            }
        }
        return result;
    }

    async saveTransfert() {
        // Проверка на повторное сохранение
        if (this.isSaving) {
            this.makeToast("warning", this.$t('modules.transfert.toasts.saving_in_progress') as string, this.$t('modules.transfert.toasts.attention_title') as string);
            return;
        }

        this.isSaving = true;
        try {
            const listToSave: TransferSaveData[] = [];
            const userId = this.$store.getters.user_uuid;
            if (this.deletedRows.length > 0) {
                const confirm = await this.$bvModal.msgBoxConfirm(
                    this.$t('modules.transfert.toasts.confirm_recipient_region_change') as string, {
                        title: this.$t('modules.transfert.toasts.confirm_title') as string,
                        okVariant: "danger",
                        okTitle: this.$t('modules.transfert.toasts.yes') as string,
                        cancelTitle: this.$t('modules.transfert.toasts.no') as string,
                    }
                );

                if (!confirm) {
                    this.isSaving = false;
                    return;
                }
                const removed = await this.deleteRecipientRegions(this.deletedRows);
                this.deletedRows = [];
                if (!removed) {
                    this.isSaving = false;
                    return;
                }
            }
            // Сначала собираем listToSave, удаление clearedRows будет после проверки
            const filteredProjects = this.transfertList.filter(project =>
                project.kbk_data?.has(this.regionFilter)
            );
            for (const transferItem of filteredProjects) {
                if (!transferItem.direction) {
                    this.$bvToast.toast(this.$t('modules.transfert.toasts.direction_not_selected', { code: transferItem.project_from_bank?.code }) as string, {
                        title: this.$t('modules.transfert.toasts.error_title') as string,
                        variant: "danger",
                        solid: true
                    });
                    continue;
                }

                if (!transferItem.project_from_bank?.code) {
                    this.$bvToast.toast(this.$t('modules.transfert.toasts.project_code_not_found') as string, {
                        title: this.$t('modules.transfert.toasts.error_title') as string,
                        variant: "danger",
                        solid: true
                    });
                    continue;
                }

                // Обработка регионов получателей
                for (const transferRegion of this.regionForTransferList.filter(r => r.region.code !== this.regionFilter)) {
                    if (!transferItem.kbk_data.has(transferRegion.region.code)) continue;
                    listToSave.push({
                        expense_code: transferItem.project_from_bank.code,
                        direction: transferItem.direction,
                        transfer_group: transferItem.transfer_group,
                        funding_source: this.get_transfer_funding_source(transferItem),
                        budget_level: this.get_region_level(transferRegion.region.code),
                        abp: 0,
                        prg: 0,
                        ppr: 0,
                        region: transferRegion.region.code,
                        year: this.cur_year,
                        user_id: userId,
                        reusable: false,
                        ensure_only: true
                    });
                }

                // Обработка КБК для текущего региона
                const kbkData = transferItem.kbk_data.get(this.regionFilter) || [];
                // Фильтруем: если есть ненулевые КБК, сохраняем только их; иначе сохраняем нулевой
                const nonZeroKbk = kbkData.filter(kbk =>
                    kbk.kbk_code.abp !== 0 || kbk.kbk_code.prg !== 0
                );
                const zeroKbk = kbkData.filter(kbk =>
                    kbk.kbk_code.abp === 0 && kbk.kbk_code.prg === 0
                );

                // Если есть ненулевые КБК, добавляем нулевые в список для удаления
                if (nonZeroKbk.length > 0 && zeroKbk.length > 0) {
                    for (const kbk of zeroKbk) {
                        const zeroKey = `${transferItem.project_from_bank.code}|${this.regionFilter}|${kbk.transfer_sources.funding_source}|${kbk.transfer_sources.budget_level}|0`;
                        if (this.clearedRows.some(r => `${this.cellKeyOf(r)}|${r.abp ?? 0}` === zeroKey)) continue;
                        this.clearedRows.push({
                            expense_code: transferItem.project_from_bank.code,
                            direction: transferItem.direction,
                            transfer_group: transferItem.transfer_group,
                            funding_source: kbk.transfer_sources.funding_source,
                            budget_level: kbk.transfer_sources.budget_level,
                            abp: kbk.kbk_code.abp,
                            prg: kbk.kbk_code.prg ?? null,
                            ppr: kbk.kbk_code.ppr ?? null,
                            region: this.regionFilter,
                            year: this.cur_year,
                            user_id: userId
                        });
                    }
                }

                const kbkToSave = nonZeroKbk.length > 0 ? nonZeroKbk : kbkData;
                for (const kbk of kbkToSave) {
                    listToSave.push({
                        expense_code: transferItem.project_from_bank.code,
                        direction: transferItem.direction,
                        transfer_group: transferItem.transfer_group,
                        funding_source: kbk.transfer_sources.funding_source,
                        budget_level: kbk.transfer_sources.budget_level,
                        abp: kbk.kbk_code.abp,
                        prg: kbk.kbk_code.prg ?? null,
                        ppr: kbk.kbk_code.ppr ?? null,
                        region: this.regionFilter,
                        year: this.cur_year,
                        user_id: userId,
                        reusable: kbk.reusable ?? false
                    });
                }
            }
            if (listToSave.some(r => !r.ensure_only)) {
                // Клетки из запроса сервер заменяет целиком, поэтому удаления по ним не нужны.
                // До сохранения удаляем только КБК, которые переехали в другую клетку (иначе сервер увидит дубль);
                // остальные удаления выполняем после успешного сохранения. При ошибке clearedRows сохраняется.
                const { before, after } = this.splitClearedRows(listToSave);
                if (before.length > 0) {
                    await this.deleteKBKFromDB(before);
                    this.clearedRows = this.clearedRows.filter(row => !before.includes(row));
                }
                const saved = await this.processSave(listToSave);
                if (saved) {
                    if (after.length > 0) {
                        await this.deleteKBKFromDB(after);
                    }
                    this.clearedRows = [];
                }
            } else {
                const confirm = await this.$bvModal.msgBoxConfirm(
                    this.$t('modules.transfert.toasts.confirm_delete_no_kbk') as string, {
                        title: this.$t('modules.transfert.toasts.confirm_title') as string,
                        okVariant: "danger",
                        okTitle: this.$t('modules.transfert.toasts.yes') as string,
                        cancelTitle: this.$t('modules.transfert.toasts.no') as string,
                    }
                );
                if (confirm) {
                    // Удаляем clearedRows только если пользователь подтвердил удаление
                    if (this.clearedRows.length > 0) {
                        await this.deleteKBKFromDB(this.clearedRows);
                        this.clearedRows = [];
                    }
                    await this.processSave([]);
                } else {
                    // Пользователь отменил - очищаем clearedRows без удаления из БД
                    this.clearedRows = [];
                }
            }
            this.transfertList = [...this.transfertList];
        } catch (error) {
            this.makeToast(
                "danger",
                this.$t('modules.transfert.toasts.error_saving') as string,
                error instanceof Error ? error.message : String(error)
            );
        } finally {
            this.isSaving = false;
        }
    }

    private cellKeyOf(row: TransferSaveData): string {
        return `${row.expense_code}|${row.region}|${row.funding_source}|${row.budget_level}`;
    }

    private kbkKeyOf(row: TransferSaveData): string {
        return `${row.expense_code}|${row.region}|${row.abp ?? 0}|${row.prg ?? 0}|${row.ppr ?? 0}`;
    }

    // Разбор отложенных удалений: before - КБК, которые снова сохраняются (в другой клетке), after - остальные
    private splitClearedRows(listToSave: TransferSaveData[]): { before: TransferSaveData[]; after: TransferSaveData[] } {
        const savedCells = new Set(listToSave.filter(r => !r.ensure_only).map(r => this.cellKeyOf(r)));
        const savedKbk = new Set(listToSave.filter(r => !r.ensure_only && (r.abp || r.prg)).map(r => this.kbkKeyOf(r)));
        const before: TransferSaveData[] = [];
        const after: TransferSaveData[] = [];
        for (const row of this.clearedRows) {
            if (savedCells.has(this.cellKeyOf(row))) continue; // клетку заменит сервер
            if (savedKbk.has(this.kbkKeyOf(row))) {
                before.push(row);
            } else {
                after.push(row);
            }
        }
        return { before, after };
    }

    async processSave(listToSave: TransferSaveData[]): Promise<boolean> {
        let saved = false;
        try {
            const response = await fetch(`/api-py/save-transfer-bulk?lang=${this.$i18n.locale}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(listToSave),
            });
            const result = await response.json().catch(() => ({} as any));

            if (response.ok && result.status === "success") {
                saved = true;
                this.makeToast("success", this.$t('modules.transfert.toasts.all_data_saved') as string, this.$t('modules.transfert.toasts.saving_title') as string);

                this.transfertList = this.transfertList.map(project => {
                    const kbkData = project.kbk_data.get(this.regionFilter);
                    if (kbkData) {
                        const nonZeroKBK = kbkData.filter(kbk =>
                            kbk.kbk_code.abp !== 0 || kbk.kbk_code.prg !== 0
                        );
                        if (nonZeroKBK.length > 0 && nonZeroKBK.length !== kbkData.length) {
                            project.kbk_data.set(this.regionFilter, nonZeroKBK);
                        }
                    }
                    return project;
                });
            } else {
                // HTTP 400 от сервера: переведённое сообщение лежит в detail (например, дубль КБК в проекте)
                const detail = typeof result.detail === 'string' ? result.detail : '';
                this.makeToast("danger", result.message || detail || this.$t('modules.transfert.toasts.some_data_not_saved') as string, this.$t('modules.transfert.toasts.error_title') as string);
            }
        } catch (error) {
            this.makeToast(
                "danger",
                this.$t('modules.transfert.toasts.error_saving_data') as string,
                error instanceof Error ? error.message : String(error)
            );
        }
        this.transfertList = [...this.transfertList];
        return saved;
    }

    hasLowerLevels(project: TransferData, kbk: TransferSaveData): boolean {
        const isRegion = kbk.budget_level === "01";
        const isDistrict = kbk.budget_level === "04";

            for (const [kbkRegion, kbkEntries] of project.kbk_data.entries()) {
                for (const entry of kbkEntries as KbkData[]) {
                    if (isRegion && entry.transfer_sources.budget_level === "04" && kbkRegion.startsWith(kbk.region.slice(0, 2))) {
                        return true;
                    }
                    if (isDistrict && entry.transfer_sources.budget_level === "05" && kbkRegion.startsWith(kbk.region)) {
                        return true;
                    }
                }
            }
        return false;
    }

    private async deleteRecipientRegions(rows: TransferSaveData[]): Promise<boolean> {
        const body = rows.map(r => ({
            expense_code: r.expense_code,
            year: r.year,
            region: r.region,
            transfer_group: r.transfer_group,
            user_id: r.user_id,
            whole_region: true
        }));
        const response = await fetch(`/api-py/delete-several-transfers?lang=${this.$i18n.locale}`, {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
        });
        if (response.ok) {
            this.deletedBackup.clear();
            return true;
        }
        const result = await response.json().catch(() => ({} as any));
        const detail = typeof result?.detail === "string" ? result.detail : JSON.stringify(result?.detail ?? "");
        for (const r of rows) {
            const backup = this.deletedBackup.get(`${r.expense_code}|${r.region}`);
            const project = this.transfertList.find(p => p.project_from_bank.code === r.expense_code && p.transfer_group === r.transfer_group);
            if (backup && project && !project.kbk_data.has(r.region)) {
                project.kbk_data.set(r.region, backup);
            }
        }
        this.deletedBackup.clear();
        this.transfertList = [...this.transfertList];
        this.makeToast("danger", this.$t('modules.transfert.toasts.error_deleting') as string, detail);
        return false;
    }

    async deleteKBKFromDB(deletedRows: TransferSaveData[]) {
        if (deletedRows.length === 0) return;
        const projectCodes = [...new Set(deletedRows.map(kbk => kbk.expense_code))];
        const projectsToUpdate = this.transfertList.filter(p =>
            projectCodes.includes(p.project_from_bank.code)
        );

        const deleteRequests = deletedRows.map(kbk => {
            const project = projectsToUpdate.find(p => p.project_from_bank.code === kbk.expense_code);
            if (!project) return null;
            const hasLower = this.hasLowerLevels(project, kbk);
            return {
                expense_code: kbk.expense_code,
                direction: project.direction,
                transfer_group: project.transfer_group,
                funding_source: kbk.funding_source,
                budget_level: kbk.budget_level,
                // exact - удаляем конкретный КБК многокодовой клетки, а не клетку целиком
                abp: hasLower && !kbk.exact ? null : kbk.abp,
                prg: hasLower && !kbk.exact ? null : kbk.prg,
                ppr: hasLower && !kbk.exact ? null : kbk.ppr,
                region: kbk.region,
                year: kbk.year,
                user_id: this.$store.getters.user_uuid,
            };
        }).filter(Boolean);
        if (deleteRequests.length === 0) return;
        await fetch(`/api-py/delete-several-transfers?lang=${this.$i18n.locale}`, {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(deleteRequests),
        });
        for (const kbk of deletedRows) {
            // exact-строки уже убраны из локальных данных (иначе заново добавленный такой же КБК пропал бы с экрана)
            if (kbk.exact) continue;
            const project = projectsToUpdate.find(p => p.project_from_bank.code === kbk.expense_code);
            if (!project) continue;

            const projectData = project.kbk_data.get(kbk.region);
            if (projectData) {
                project.kbk_data.set(kbk.region, projectData.filter(entry =>
                    entry.kbk_code.abp !== kbk.abp ||
                    entry.kbk_code.prg !== kbk.prg ||
                    entry.kbk_code.ppr !== kbk.ppr
                ));
            }
        }
        this.transfertList = [...this.transfertList];
    }

    isLowerLevelKBKEmpty(expenseCode: string, region: string): boolean {
        const project = this.transfertList.find(p => p.project_from_bank.code === expenseCode);
        if (!project) return true;

        const kbkEntries = project.kbk_data.get(region) || [];
        return kbkEntries.every(kbk => {
            if (kbk.transfer_sources.budget_level === "01" && this.regionFilter.endsWith("0101")) return true;
            if (kbk.transfer_sources.budget_level === "04" && this.regionFilter.endsWith("01")) return true;
            return !kbk.kbk_code.abp && !kbk.kbk_code.prg && !kbk.kbk_code.ppr;
        });
    }

    async deleteTransfert(transfert: TransferData) {
        const code = transfert.project_from_bank?.code ?? '';
        const kbkRows: Array<{ expense_code: string; year: number; abp: number; prg: number; ppr: number | null }> = [];
        for (const [, kbkList] of transfert.kbk_data) {
            for (const kbk of kbkList.filter(k => k.kbk_code.abp !== 0 || k.kbk_code.prg !== 0)) {
                kbkRows.push({
                    expense_code: code,
                    year: this.cur_year,
                    abp: kbk.kbk_code.abp,
                    prg: kbk.kbk_code.prg ?? 0,
                    ppr: kbk.kbk_code.ppr ?? null,
                });
            }
        }
        if (kbkRows.length === 0) {
            kbkRows.push({ expense_code: code, year: this.cur_year, abp: 0, prg: 0, ppr: null });
        }
        const allowed = await this.checkRelations(kbkRows);
        if (!allowed) return;
        const checkResult = this.checkDeleteConditions(transfert);
        if (checkResult.disabled) {
            this.makeToast("danger", checkResult.message, this.$t('modules.transfert.toasts.error_title') as string);
            return;
        }

        const confirm = await this.$bvModal.msgBoxConfirm(checkResult.message, {
            title: this.$t('modules.transfert.toasts.confirm_title') as string,
            okVariant: checkResult.color === "red" ? "danger" : "warning",
            okTitle: this.$t('modules.transfert.delete') as string,
            cancelTitle: this.$t('modules.transfert.cancel') as string,
        });

        if (!confirm) return;
        await this.delete(transfert);
    }

    async deleteWithLowerEmptyKBK(transfert: TransferData, lowerRegions: string[]) {
        const expenseCode = transfert.project_from_bank.code;
        await this.delete(transfert);
        const deleteRequests = lowerRegions
            .filter(region => this.isLowerLevelKBKEmpty(expenseCode, region))
            .map(region => ({
                expense_code: expenseCode,
                direction: transfert.direction,
                transfer_group: transfert.transfer_group,
                region: region,
                year: this.cur_year,
                user_id: this.$store.getters.user_uuid,
            }));
        if (deleteRequests.length > 0) {
            await fetch(`/api-py/delete-several-transfers?lang=${this.$i18n.locale}`, {
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(deleteRequests),
            });
            this.transfertList = this.transfertList.map(project => {
                if (project.project_from_bank.code === expenseCode) {
                    deleteRequests.forEach(req => project.kbk_data.delete(req.region));
                }
                return project;
            }).filter(project => project.kbk_data.size > 0);
            this.applyFilters();
        }
    }

    async delete(transfert: TransferData) {
        const deleteData = {
            expense_code: transfert.project_from_bank.code,
            direction: transfert.direction,
            transfer_group: transfert.transfer_group,
            region: this.regionFilter,
            year: this.cur_year,
            user_id: this.$store.getters.user_uuid,
        };
        const response = await fetch(`/api-py/delete-transfer?lang=${this.$i18n.locale}`, {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(deleteData)
        });
        const result = await response.json();
        if (response.status === 200 && result.status === "success") {
            this.makeToast("success", this.$t('modules.transfert.toasts.deleted_title') as string, this.$t('modules.transfert.toasts.project_deleted') as string);
            const isDeleted = (p: TransferData) => p === transfert || (
                p.project_from_bank.code === transfert.project_from_bank.code &&
                (p.transfer_group ?? "") === (transfert.transfer_group ?? ""));
            this.transfertList = this.transfertList.filter(p => !isDeleted(p));
            if (this.selectedProject && isDeleted(this.selectedProject)) {
                this.selectedProject = null;
            }
        } else {
            this.makeToast("danger", this.$t('modules.transfert.toasts.error_deleting') as string, this.$t('modules.transfert.toasts.error_title') as string);
        }
        this.transfertList = [...this.transfertList];
        this.applyFilters();
    }

    checkDeleteConditions(project: TransferData) {
        const isRegion = this.regionFilter.endsWith("0101");
        const isDistrict = !isRegion && this.regionFilter.endsWith("01");
        const isLocalGov = !isRegion && !isDistrict;

        let hasLowerDistribution = false;
        let hasUpperDistribution = false;

        for (const [kbkRegion, kbkEntries] of project.kbk_data.entries()) {
            for (const kbkEntry of kbkEntries) {
                const budgetLevel = kbkEntry.transfer_sources.budget_level;

                if (isRegion && ["04", "05"].includes(budgetLevel)) {
                    hasLowerDistribution = true;
                }
                if (isDistrict && budgetLevel === "05") {
                    hasLowerDistribution = true;
                }
                if (isDistrict && ["01", "02", "03"].includes(budgetLevel)) {
                    hasUpperDistribution = true;
                }
                if (isLocalGov && budgetLevel === "04") {
                    hasUpperDistribution = true;
                }
            }
        }
        if (isRegion) {
            if (hasLowerDistribution) {
                return {
                    disabled: true,
                    color: "gray",
                    message: this.$t('modules.transfert.toasts.has_lower_distribution_cant_delete') as string,
                };
            }
            return { disabled: false, color: "red", message: this.$t('modules.transfert.toasts.confirm_delete_project') as string };
        }

        if (isDistrict) {
            if (hasUpperDistribution) {
                return {
                    disabled: true,
                    color: "gray",
                    message: this.$t('modules.transfert.toasts.delete_only_from_upper_level') as string,
                };
            }
            if (hasLowerDistribution) {
                return {
                    disabled: true,
                    color: "gray",
                    message: this.$t('modules.transfert.toasts.has_lower_distribution_cant_delete') as string,
                };
            }
            return { disabled: false, color: "red", message: this.$t('modules.transfert.toasts.confirm_delete_project') as string };
        }

        if (isLocalGov) {
            if (hasUpperDistribution) {
                return {
                    disabled: true,
                    color: "gray",
                    message: this.$t('modules.transfert.toasts.delete_only_from_upper_level') as string,
                };
            }
            return { disabled: false, color: "red", message: this.$t('modules.transfert.toasts.confirm_delete_project') as string };
        }

        return { disabled: true, color: "gray", message: this.$t('modules.transfert.toasts.error_checking') as string };
    }

    getLowerRegions(transfert: TransferData) {
        const lowerRegions = new Set<string>();
        const currentRegion = this.regionFilter;

        for (const kbkRegion of transfert.kbk_data.keys()) {
            if (currentRegion.endsWith("0101")) {
                if (kbkRegion.startsWith(currentRegion.slice(0, 2)) && kbkRegion.endsWith("01") && kbkRegion !== currentRegion) {
                    lowerRegions.add(kbkRegion);
                }
            } else if (currentRegion.endsWith("01")) {
                if (kbkRegion.startsWith(currentRegion.slice(0, 4)) && !kbkRegion.endsWith("01")) {
                    lowerRegions.add(kbkRegion);
                }
            }
        }
        return Array.from(lowerRegions);
    }

    get selectedGroupCaption() {
        if (this.selectedProject != null) {
            let caption = this.selectedProject?.transfer_group;
            if (caption != "") {
                caption =
                    caption +
                    "-" +
                    this.dict_transfer_group.find((value) => value.code == caption)
                        ?.name_ru;
            }
            return caption;
        } else {
            return "";
        }
    }

    selectedProject: TransferData | null = null;
    isSaving = false;

    get selectedProjectCaption() {
        if (this.selectedProject != null) {
            return (
                this.selectedProject?.project_from_bank.code +
                "-" +
                this.selectedProject?.project_from_bank.name_ru
            );
        } else {
            return "";
        }
    }

    private async loadTransfers() {
        this.loading = true;
        // несохранённые локальные удаления не переносим на новую выборку (иначе КБК тихо удалится из БД)
        this.clearedRows = [];
        this.deletedRows = [];
        this.deletedBackup.clear();
        try {
            const response = await fetch(`/api-py/get-transfers/${this.cur_year}`);
            const transferBase = (await response.json()) as TransferSaveData[];

            const transferMap = new Map<string, TransferData>();
            const directionsByKey = new Map<string, Map<string, string>>();
            for (const trd of transferBase) {
                const key = `${trd.expense_code}_${trd.transfer_group}`;
                if (trd.direction) {
                    const byRegion = directionsByKey.get(key) ?? new Map<string, string>();
                    if (!byRegion.has(trd.region)) byRegion.set(trd.region, trd.direction);
                    directionsByKey.set(key, byRegion);
                }
                const kbk_code: KbkCode = {
                    abp: trd.abp || 0,
                    prg: trd.prg || 0,
                    ppr: trd.ppr || 0
                };
                const kbk_source: TransferSources = {
                    budget_level: trd.budget_level || "03",
                    funding_source: trd.funding_source || "03"
                };

                if (!transferMap.has(key)) {
                    // const project = this.modalProjectList.find(p => p.code === trd.expense_code);
                    const project = trd.expense_code
                        ? this.projectMap.get(trd.expense_code)
                        : undefined;

                    // Если проект не найден, заглушку с минимальными данными
                    const projectData = project ?? {
                        id: 0,
                        code: trd.expense_code ?? "N/A",
                        budget_region: null,
                        name_kz: "Жоба табылмады",
                        name_ru: this.$t('modules.transfert.project_not_found') as string,
                        abp: 0,
                        is_archive: false,
                        funding: "01",
                        amount_rep_budget: 0,
                        amount_local_budget: 0,
                        project_type: "other",
                        branch: null,
                        prg: null,
                        concept: null,
                        begin_date: new Date().toISOString(),
                        end_date: new Date().toISOString(),
                        location: null,
                        purpose_kz: "",
                        purpose_ru: "",
                        task_name_kz: "",
                        task_name_ru: "",
                        result_kz: "",
                        result_ru: "",
                        indicator_kz: "",
                        indicator_ru: "",
                        direct_result_kz: "",
                        direct_result_ru: "",
                        final_result_kz: "",
                        final_result_ru: "",
                        key_indicator_kz: "",
                        key_indicator_ru: "",
                        unit: null,
                        user_id: "",
                        created_at: new Date().toISOString(),
                        updated_at: new Date().toISOString(),
                        is_deleted: false
                    };

                    transferMap.set(key, {
                        checked: false,
                        transfer_group: trd.transfer_group ?? "",
                        direction: trd.direction ?? "",
                        year: trd.year,
                        project_from_bank: projectData,
                        transfer_group_list: [],
                        kbk_data: new Map<string, KbkData[]>(),
                        status: ""
                    });
                }

                const transferItem = transferMap.get(key)!;
                const regionKbk = transferItem.kbk_data.get(trd.region) ?? [];

                regionKbk.push({
                    kbk_code: kbk_code,
                    transfer_sources: kbk_source,
                    reusable: trd.reusable ?? false
                });

                transferItem.kbk_data.set(trd.region, regionKbk);
                transferItem.status = this.calcStatus(transferItem);
            }
            const regionChain = [this.regionFilter, `${this.regionFilter.slice(0, 4)}01`, `${this.regionFilter.slice(0, 2)}0101`];
            for (const [key, item] of transferMap) {
                const byRegion = directionsByKey.get(key);
                if (!byRegion) continue;
                const chainRegion = regionChain.find(r => byRegion.has(r));
                if (chainRegion) item.direction = byRegion.get(chainRegion)!;
            }
            console.debug("Start transferBase: ");
            this.transfertList = Array.from(transferMap.values());
            this.transfertList = this.transfertList.filter(value => {
                if (!value.kbk_data.has(this.regionFilter)) {
                    return false;
                }

                if (this.transferGroupFilter && value.transfer_group !== this.transferGroupFilter) {
                    return false;
                }
                return true;
            })
            this.mounted_data = true;
            this.applyFilters();
            console.debug("Stop");
        } catch (error) {
            this.makeToast(
                "danger",
                this.$t('modules.transfert.toasts.error_load_transfers') as string,
                error instanceof Error ? error.message : String(error)
            );
        } finally {
            this.loading = false;
        }
    }

    region_kbk_data(region: string) {
        let result = "";
        if (this.selectedProject != null) {
            const kbk_data = this.selectedProject.kbk_data.get(region)
            if (kbk_data?.[0]?.kbk_code) {
                result = `${kbk_data[0].kbk_code.abp}.${kbk_data[0].kbk_code.prg}.${kbk_data[0].kbk_code.ppr ?? '000'}`;
            }
        }
        return result
    }

    showKbkModal = false;
    selectedKbk: KbkCode = { abp: 0, prg: 0, ppr: 0 };

    // Клетки КБК (ОБ) и КБК (Район) содержат несколько КБК, остальные - один
    isMultiLevel(budget_level: string): boolean {
        return ["03", "04"].includes(budget_level);
    }

    // Право редактировать клетку с несколькими КБК: правила клетки + доступ не «Просмотр»
    canEditMultiCell(budget_level: string, funding_source: string): boolean {
        return !this.isItemDisabled && this.isFieldEditable(budget_level, funding_source);
    }

    isZeroKbk(kbk: KbkData): boolean {
        return !kbk.kbk_code.abp && !kbk.kbk_code.prg && !kbk.kbk_code.ppr;
    }

    colLabel(budget_level: string): string {
        const colKeys: Record<string, string> = {
            "01": "kbk_national_fund",
            "02": "kbk_republican",
            "03": "kbk_oblast",
            "04": "kbk_district",
            "05": "kbk_msu",
        };
        return this.$t('modules.transfert.' + (colKeys[budget_level] ?? 'kbk_oblast')) as string;
    }

    // Подпись клетки «{колонка} · {строка}» для окон выбора/подтверждения
    cellCaption(budget_level: string, funding_source: string): string {
        const col = this.colLabel(budget_level);
        const row = this.$t('modules.transfert.funding_levels.' + funding_source) as string;
        return `${col} · ${row}`;
    }

    // Единое открытие окна выбора КБК
    private openKbkModal(mode: 'single' | 'add' | 'edit', budget_level: string, funding_source: string, target: KbkData | null) {
        this.modalMode = mode;
        this.modalTarget = target;
        this.modalSource = { ...this.modalSource, funding_source, budget_level };
        this.modalKbk = target?.kbk_code ? { ...target.kbk_code } : { abp: 0, prg: 0, ppr: 0 };
        this.modalReusable = target?.reusable ?? false;
        this.modalContext = this.$t('modules.transfert.modal_context', {
            col: this.colLabel(budget_level),
            row: this.$t('modules.transfert.funding_levels.' + funding_source) as string,
            code: this.selectedProject?.project_from_bank.code ?? ''
        }) as string;
        this.modalOthers = mode === 'single'
            ? []
            : this.cellKbks(budget_level, funding_source).filter(k => k !== target).map(k => this.kbkToString(k));
        this.selectedKbk = { abp: 0, prg: 0, ppr: 0 };
        this.showKbkModal = false;
        this.$nextTick(() => {
            this.showKbkModal = true;
        });
        this.$bvModal.show("transfer_kbk_add_modal");
    }

    // Клетки с одним КБК (Нац. фонд, РБ, МСУ): двойной клик = выбор/замена КБК
    async transfer_kbk_add(budget_level: string, funding_source: string) {
        if (this.isMultiLevel(budget_level)) {
            await this.openKbkAdd(budget_level, funding_source);
            return;
        }
        const kbkObject = this.findKbkObject(budget_level, funding_source, this.regionFilter);
        const current: KbkCode = kbkObject ? { ...kbkObject.kbk_code } : { abp: 0, prg: 0, ppr: 0 };

        const rows: TransferSaveData[] = [{
            expense_code: this.selectedProject?.project_from_bank.code,
            direction: this.selectedProject?.direction,
            transfer_group: this.selectedProject?.transfer_group,
            funding_source,
            budget_level,
            abp: current.abp,
            prg: current.prg,
            ppr: current.ppr,
            region: this.regionFilter,
            year: this.cur_year,
            user_id: this.$store.getters.user_uuid,
        }];

        if (current.abp !== 0) {
            const checksPassed = await this.checkAllBlockers(rows, ['bip']);
            if (!checksPassed) return;
        }

        this.openKbkModal('single', budget_level, funding_source, kbkObject);
    }

    // Добавить КБК в клетку с несколькими КБК
    async openKbkAdd(budget_level: string, funding_source: string) {
        if (!this.canEditMultiCell(budget_level, funding_source)) return;
        this.openKbkModal('add', budget_level, funding_source, null);
    }

    // Все КБК клетки: свой регион + унаследованные от вышестоящих регионов (район видит все областные КБК)
    findKbkObjects(budget_level: string, funding_source: string, regionKey: string): KbkData[] {
        const self_level = this.get_region_level(regionKey);
        const kbk_map = this.selectedProject?.kbk_data;
        const result: KbkData[] = [];
        if (!kbk_map) return result;

        for (const key of kbk_map.keys()) {
            const key_level = this.get_region_level(key);
            const isParent = key_level < self_level && this.is_region_parent(regionKey, key);
            const isSameLevel = key_level === self_level && key === regionKey;
            if (!isParent && !isSameLevel) continue;
            for (const value of kbk_map.get(key) ?? []) {
                if (value.transfer_sources.funding_source === funding_source &&
                    value.transfer_sources.budget_level === budget_level) {
                    result.push(value);
                }
            }
        }
        return result;
    }

    // КБК клетки для показа: без нулевой заглушки, по возрастанию АБП -> ПРГ -> ППР
    cellKbks(budget_level: string, funding_source: string): KbkData[] {
        // зависимость для перерисовки после локальных изменений kbk_data
        if (this.kbkTick < 0) return [];
        return this.findKbkObjects(budget_level, funding_source, this.regionFilter)
            .filter(k => !this.isZeroKbk(k))
            .sort((a, b) =>
                (a.kbk_code.abp - b.kbk_code.abp) ||
                ((a.kbk_code.prg ?? 0) - (b.kbk_code.prg ?? 0)) ||
                ((a.kbk_code.ppr ?? 0) - (b.kbk_code.ppr ?? 0)));
    }

    bumpKbkView() {
        this.kbkTick++;
        this.$refs.myTable?.refresh?.();
    }

    kbkSaveRow(kbk: KbkData, region: string = this.regionFilter): TransferSaveData {
        const exact = this.isMultiLevel(kbk.transfer_sources.budget_level);
        return {
            expense_code: this.selectedProject?.project_from_bank.code,
            direction: this.selectedProject?.direction,
            transfer_group: this.selectedProject?.transfer_group,
            funding_source: kbk.transfer_sources.funding_source,
            budget_level: kbk.transfer_sources.budget_level,
            abp: kbk.kbk_code.abp,
            prg: exact ? (kbk.kbk_code.prg ?? 0) : (kbk.kbk_code.prg ?? null),
            ppr: exact ? (kbk.kbk_code.ppr ?? 0) : (kbk.kbk_code.ppr ?? null),
            region,
            year: this.cur_year,
            user_id: this.$store.getters.user_uuid,
            exact,
        };
    }

    // Проверка связанных данных по одному КБК. null - проверка не удалась (действие не выполняем)
    async getKbkBlockers(kbk: KbkData): Promise<RelationResult[] | null> {
        try {
            const { results } = await this.checkRelationsPerRow([this.kbkSaveRow(kbk)]);
            return results;
        } catch (error) {
            this.makeToast(
                "danger",
                this.$t('modules.transfert.toasts.error_checking') as string,
                error instanceof Error ? error.message : String(error)
            );
            return null;
        }
    }

    // Признак выполняющегося действия над КБК (проверка связей/подтверждение) - защита от повторного клика
    kbkBusy = false;

    // Изменение КБК (клик по коду): сначала связи, есть - NTF.04, иначе окно в режиме изменения
    async editKbk(budget_level: string, funding_source: string, kbk: KbkData) {
        if (this.kbkBusy || !this.canEditMultiCell(budget_level, funding_source)) return;
        this.kbkBusy = true;
        try {
            const blockers = await this.getKbkBlockers(kbk);
            if (blockers === null) return;
            if (blockers.length > 0) {
                this.relationsModalTitle = null;
                this.relationsCheckResults = blockers;
                this.$bvModal.show('transfer-relations-modal');
                return;
            }
            this.openKbkModal('edit', budget_level, funding_source, kbk);
        } finally {
            this.kbkBusy = false;
        }
    }

    // Удаление одного КБК из клетки («×» или «Удалить» в окне): связи -> NTF.03, иначе подтверждение NTF.02
    async removeKbk(budget_level: string, funding_source: string, kbk: KbkData) {
        if (this.kbkBusy || !this.canEditMultiCell(budget_level, funding_source)) return;
        this.kbkBusy = true;
        try {
            const kbkStr = this.kbkToString(kbk);
            const blockers = await this.getKbkBlockers(kbk);
            if (blockers === null) return;
            if (blockers.length > 0) {
                this.relationsModalTitle = this.$t('modules.transfert.toasts.cannot_delete_kbk_related', { kbk: kbkStr }) as string;
                this.relationsCheckResults = blockers;
                this.$bvModal.show('transfer-relations-modal');
                return;
            }
            const h = this.$createElement;
            const message = h('div', [
                h('div', this.$t('modules.transfert.toasts.confirm_delete_kbk', {
                    kbk: kbkStr,
                    cell: this.cellCaption(budget_level, funding_source)
                }) as string),
                h('div', { class: 'mt-2 text-muted' }, this.$t('modules.transfert.toasts.confirm_delete_kbk_hint') as string),
            ]);
            const confirm = await this.$bvModal.msgBoxConfirm([message], {
                title: this.$t('modules.transfert.toasts.confirm_title') as string,
                okVariant: "danger",
                okTitle: this.$t('modules.transfert.delete') as string,
                cancelTitle: this.$t('modules.transfert.cancel') as string,
            });
            if (!confirm) return;
            this.removeKbkLocal(kbk);
        } finally {
            this.kbkBusy = false;
        }
    }

    // Локальное удаление КБК; в БД попадёт при «Сохранить» (clearedRows удаляет именно этот КБК)
    private removeKbkLocal(kbk: KbkData) {
        if (!this.selectedProject) return;
        // ищем КБК по всем регионам проекта (свой регион в приоритете), чтобы действие не терялось молча
        let regionKey: string | null = null;
        let kbkList: KbkData[] | undefined = this.selectedProject.kbk_data.get(this.regionFilter);
        if (kbkList && kbkList.indexOf(kbk) !== -1) {
            regionKey = this.regionFilter;
        } else {
            for (const [key, list] of this.selectedProject.kbk_data.entries()) {
                if (list.indexOf(kbk) !== -1) {
                    regionKey = key;
                    kbkList = list;
                    break;
                }
            }
        }
        if (regionKey === null || !kbkList) {
            this.makeToast(
                "danger",
                this.$t('modules.transfert.toasts.error_deleting') as string,
                this.$t('modules.transfert.toasts.error_title') as string
            );
            return;
        }

        if (!this.isZeroKbk(kbk)) {
            this.clearedRows.push(this.kbkSaveRow(kbk, regionKey));
        }
        const remaining = kbkList.filter(item => item !== kbk);
        // заглушка сохраняет источник финансирования и уровень бюджета клетки
        this.selectedProject.kbk_data.set(regionKey,
            remaining.length > 0 ? remaining : [{
                kbk_code: { abp: 0, prg: 0, ppr: 0 },
                transfer_sources: { ...kbk.transfer_sources }
            }]
        );
        this.bumpKbkView();
    }

    // Дубль КБК (abp+prg+ppr) в проекте+регионе в любой клетке; exclude - изменяемый КБК
    isKbkDuplicateInProject(kbk: KbkCode, exclude?: KbkData | null): boolean {
        if (!kbk.abp && !kbk.prg && !kbk.ppr) return false;
        const kbk_list = this.selectedProject?.kbk_data?.get(this.regionFilter);
        if (!kbk_list) return false;

        for (const item of kbk_list) {
            if (item === exclude) continue;
            if (
                (item.kbk_code.abp ?? 0) === (kbk.abp ?? 0) &&
                (item.kbk_code.prg ?? 0) === (kbk.prg ?? 0) &&
                (item.kbk_code.ppr ?? 0) === (kbk.ppr ?? 0)
            ) {
                return true;
            }
        }
        return false;
    }

    isModalKbkDuplicate(kbk: KbkCode): boolean {
        return this.isKbkDuplicateInProject(kbk, this.modalTarget);
    }

    addKbk(kbk: KbkCode, reusable: boolean = false) {
        if (this.isKbkDuplicateInProject(kbk, this.modalTarget)) {
            this.makeToast("warning", this.$t('modules.transfert.toasts.kbk_already_exists') as string, this.$t('modules.transfert.toasts.error_title') as string);
            return;
        }

        // single: замена КБК клетки; edit: замена изменяемого КБК
        const replaced = this.modalMode === 'add' ? null : this.modalTarget;
        if (replaced) {
            this.$set(replaced, "kbk_code", { ...kbk });
            this.$set(replaced, "reusable", reusable);
            this.bumpKbkView();
            return;
        }

        const kbk_list = this.selectedProject?.kbk_data.get(this.regionFilter);
        // нулевую заглушку этой клетки не оставляем рядом с ненулевыми КБК - занимаем её
        const placeholder = kbk_list?.find(item =>
            this.isZeroKbk(item) &&
            item.transfer_sources.funding_source === this.modalSource.funding_source &&
            item.transfer_sources.budget_level === this.modalSource.budget_level
        );
        if (placeholder) {
            this.$set(placeholder, "kbk_code", { ...kbk });
            this.$set(placeholder, "reusable", reusable);
            this.bumpKbkView();
            return;
        }

        const kbk_data: KbkData = {
            kbk_code: {...kbk},
            transfer_sources: {...this.modalSource},
            reusable
        };
        if (kbk_list) {
            kbk_list.push(kbk_data);
        } else {
            this.selectedProject?.kbk_data.set(this.regionFilter, [kbk_data]);
        }
        this.bumpKbkView();
    }

    // «Удалить» в окне выбора КБК
    deleteKbkSelection() {
        if (!this.selectedProject) return;
        const target = this.modalTarget;
        if (!target) return;
        if (this.modalMode === 'edit') {
            // клетка с несколькими КБК: проверка связей и подтверждение
            this.removeKbk(this.modalSource.budget_level, this.modalSource.funding_source, target);
            return;
        }
        if (this.isZeroKbk(target)) return;
        this.removeKbkLocal(target);
    }

    // Наименования АБП/программы/подпрограммы для тултипа кода (подгружаются при наведении)
    kbkNames: Record<string, { abp?: any; prg?: any; ppr?: any }> = {};
    private kbkNamesLoading: Set<string> = new Set();
    private abpNames: Record<string, any[]> = {};

    private kbkNamesKey(kbk: KbkData): string {
        const p = this.selectedProject?.project_from_bank;
        return `${this.cur_year}|${p?.code}|${kbk.kbk_code.abp}|${kbk.kbk_code.prg ?? 0}|${kbk.kbk_code.ppr ?? 0}`;
    }

    private async fetchJson(url: string): Promise<any[]> {
        try {
            const resp = await fetch(url);
            const data = await resp.json();
            return Array.isArray(data) ? data : [];
        } catch {
            return [];
        }
    }

    private async loadAbpNames(): Promise<any[]> {
        const yearKey = String(this.cur_year);
        if (this.abpNames[yearKey]) return this.abpNames[yearKey];
        const sub = store.state.user.sub;
        const [byUser, byLevel] = await Promise.all([
            sub ? this.fetchJson(`/api-py/get-abp-by-user-id/${sub}/${this.cur_year}`) : Promise.resolve([]),
            this.userBudgetLevel ? this.fetchJson(`/api-py/get-abp-by-user-budget-level/${this.userBudgetLevel}/${this.cur_year}`) : Promise.resolve([])
        ]);
        this.abpNames[yearKey] = [...byUser, ...byLevel];
        return this.abpNames[yearKey];
    }

    async loadKbkNames(kbk: KbkData) {
        const key = this.kbkNamesKey(kbk);
        if (this.kbkNames[key] || this.kbkNamesLoading.has(key)) return;
        const project = this.selectedProject?.project_from_bank;
        if (!project) return;
        this.kbkNamesLoading.add(key);
        try {
            const { abp, prg, ppr } = kbk.kbk_code;
            const firstDay = `${this.cur_year}-01-01`;
            const abps = await this.loadAbpNames();
            const names: { abp?: any; prg?: any; ppr?: any } = {
                abp: abps.find(item => item.abp === abp)
            };
            if (abp && prg) {
                const progs = await this.fetchJson(`/api-py/get-programs-by-parent-type-actual/${abp}/4/${project.begin_date}/${project.end_date}/${firstDay}`);
                names.prg = progs.find(item => item.prg === prg);
                if (ppr) {
                    const subs = await this.fetchJson(`/api-py/get-subprograms-by-abp-prg/${abp}/${prg}/${project.begin_date}/${project.end_date}/${firstDay}`);
                    names.ppr = subs.find(item => item.ppr === ppr);
                }
            }
            this.$set(this.kbkNames, key, names);
        } finally {
            this.kbkNamesLoading.delete(key);
        }
    }

    // Тултип кода: у редактируемого начинается с «Изменить КБК», далее наименования АБП/ПРГ/ППР
    kbkTitle(kbk: KbkData, editable: boolean): string {
        const pad = (n: number | null | undefined) => String(n ?? 0).padStart(3, '0');
        const nm = (item: any) => item ? (this.$i18n.locale === 'kk' && item.name_kk ? item.name_kk : (item.name_ru ?? '')) : '';
        const names = this.kbkNames[this.kbkNamesKey(kbk)];
        const lines: string[] = [];
        if (editable) lines.push(this.$t('modules.transfert.edit_kbk_title') as string);
        if (!names) {
            lines.push(this.kbkToString(kbk));
        } else {
            lines.push(`${this.$t('modules.transfert.abp')}: ${pad(kbk.kbk_code.abp)} - ${nm(names.abp)}`);
            lines.push(`${this.$t('modules.transfert.prg')}: ${pad(kbk.kbk_code.prg)} - ${nm(names.prg)}`);
            lines.push(`${this.$t('modules.transfert.ppr')}: ${pad(kbk.kbk_code.ppr)} - ${nm(names.ppr)}`);
        }
        return lines.join('\n');
    }


    private kbkRowKey(row: { expense_code?: string; year?: number; abp?: number | null; prg?: number | null; ppr?: number | null }): string {
        return `${row.expense_code}|${row.year}|${row.abp}|${row.prg}|${row.ppr ?? ''}`;
    }

    async checkRelationsPerRow(rows: TransferSaveData[], skipSources: string[] = []): Promise<{ blockedKeys: Set<string>; results: RelationResult[] }> {
        const meaningful = rows.filter(r => r.expense_code);
        const blockedKeys = new Set<string>();
        const results: RelationResult[] = [];
        if (meaningful.length === 0) return { blockedKeys, results };

        const seen = new Set<string>();
        const unique = meaningful.filter(r => {
            const key = this.kbkRowKey(r);
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });

        await Promise.all(unique.map(async (r) => {
            const params = new URLSearchParams({
                year: String(r.year ?? this.cur_year),
                expense_code: r.expense_code!,
                abp: String(r.abp ?? 0),
                prg: String(r.prg ?? 0),
            });
            if (r.ppr != null && r.ppr !== 0) params.set('ppr', String(r.ppr));
            // Клетки КБК (ОБ)/(Район): БИП проверяется по конкретному КБК и не пропускается
            const byKbk = this.isMultiLevel(r.budget_level ?? '');
            if (byKbk) {
                params.set('by_kbk', 'true');
                if (r.region) params.set('region', String(r.region));
            }

            const resp = await fetch(`/api-py/check-relations?${params}`);
            const data: RelationResult[] = await resp.json();
            const skip = byKbk ? [] : skipSources;
            const visible = skip.length ? data.filter(x => !skip.includes(x.source)) : data;
            const blocked = visible.filter(x => x.action === 'block');
            if (blocked.length > 0) {
                blockedKeys.add(this.kbkRowKey(r));
                results.push(...blocked);
            }
        }));

        return { blockedKeys, results };
    }

    async clearKBK() {
        if (!this.selectedProject) {
            return;
        }
        const kbkData = this.selectedProject?.kbk_data.get(this.regionFilter) || [];
        const nonZeroKbk = kbkData.filter(kbk => kbk.kbk_code.abp !== 0 || kbk.kbk_code.prg !== 0 || kbk.kbk_code.ppr !== 0);
        if (nonZeroKbk.length === 0) {
            return;
        }

        const toRow = (kbk: KbkData): TransferSaveData => this.kbkSaveRow(kbk);

        const rows = nonZeroKbk.map(toRow);
        const { blockedKeys, results } = await this.checkRelationsPerRow(rows, ['bip']);

        const clearableKbk = nonZeroKbk.filter(kbk => !blockedKeys.has(this.kbkRowKey(toRow(kbk))));
        const blockedKbk = nonZeroKbk.filter(kbk => blockedKeys.has(this.kbkRowKey(toRow(kbk))));

        if (clearableKbk.length === 0) {
            this.relationsModalTitle = this.$t('modules.transfert.toasts.cannot_clear_kbk_related') as string;
            this.relationsCheckResults = results;
            this.$bvModal.show('transfer-relations-modal');
            return;
        }

        if (blockedKbk.length > 0) {
            this.makeToast(
                "warning",
                this.$t('modules.transfert.toasts.kbk_partially_cleared') as string,
                this.$t('modules.transfert.toasts.attention_title') as string
            );
        }

        this.clearedRows.push(...clearableKbk.map(toRow));

        const remaining: KbkData[] = blockedKbk.length > 0
            ? blockedKbk
            : [{
                kbk_code: { abp: 0, prg: 0, ppr: 0 },
                // заглушка сохраняет источник финансирования и уровень бюджета очищенной клетки
                transfer_sources: { ...clearableKbk[0].transfer_sources }
            }];

        this.selectedProject.kbk_data.set(this.regionFilter, remaining);
        this.bumpKbkView();
    }


    relationsCheckResults: RelationResult[] = [];
    // null - показывать общий текст по умолчанию (переводится реактивно в TransferRelationsModal)
    relationsModalTitle: string | null = null;

    async checkRelations(rows: Array<{
        expense_code?: string;
        year?: number;
        abp?: number | null;
        prg?: number | null;
        ppr?: number | null;
    }>, skipSources: string[] = []): Promise<boolean> {
        const meaningful = rows.filter(r => r.expense_code);
        if (meaningful.length === 0) return true;

        const seen = new Set<string>();
        const unique = meaningful.filter(r => {
            const key = `${r.expense_code}|${r.year}|${r.abp}|${r.prg}|${r.ppr ?? ''}`;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });

        const allResults: RelationResult[] = [];
        await Promise.all(unique.map(async (r) => {
            const params = new URLSearchParams({
                year: String(r.year ?? this.cur_year),
                expense_code: r.expense_code!,
                abp: String(r.abp ?? 0),
                prg: String(r.prg ?? 0),
            });
            if (r.ppr != null && r.ppr !== 0) params.set('ppr', String(r.ppr));

            const resp = await fetch(`/api-py/check-relations?${params}`);
            const data: RelationResult[] = await resp.json();
            allResults.push(...data);
        }));

        const visibleResults = skipSources.length
            ? allResults.filter(r => !skipSources.includes(r.source))
            : allResults;

        const hasBlock = visibleResults.some(r => r.action === 'block');

        if (hasBlock) {
            this.relationsModalTitle = null;
            this.relationsCheckResults = visibleResults;
            this.$bvModal.show('transfer-relations-modal');
            return false;
        }
        return true;
    }


    async checkAllBlockers(rows: TransferSaveData[], skipSources: string[] = []): Promise<boolean> {
        return this.checkRelations(rows, skipSources);
    }

    get_region_level(region_code: string) {
        if (region_code.endsWith("0101")) return "03";
        if (region_code.endsWith("01")) return "04"
        return "05"
    }

    is_region_parent(child_code: string, parent_code: string): boolean {
        const ch_level = this.get_region_level(child_code);
        const par_level = this.get_region_level(parent_code);

        if (ch_level === '05' && par_level === '04') {
            return child_code.substring(0, 4) === parent_code.substring(0, 4);
        }

        const higherLevels = ["03", "02", "01"];
        if (["05", "04", "03", "02"].includes(ch_level) && higherLevels.includes(par_level)) {
            return child_code.substring(0, 2) === parent_code.substring(0, 2);
        }

        return false;
    }

    findKbkObject(budget_level: string, funding_source: string, regionKey: string): KbkData | null {
        const self_level = this.get_region_level(regionKey);
        const kbk_map = this.selectedProject?.kbk_data;
        if (!kbk_map) return null;

        for (const key of kbk_map.keys()) {
            const key_level = this.get_region_level(key);
            const isParent = key_level < self_level && this.is_region_parent(regionKey, key);
            const isSameLevel = key_level === self_level && key === regionKey;

            if (!isParent && !isSameLevel) continue;
            const kbk_array = kbk_map.get(key);
            if (!kbk_array || kbk_array.length === 0) continue;

            const kbk = kbk_array.find(
                value =>
                    value.transfer_sources.funding_source === funding_source &&
                    value.transfer_sources.budget_level === budget_level
            );
            if (kbk) {
                return kbk;
            }
        }
        return null;
    }

    kbkToString(kbk: KbkData): string {
        if (!kbk) return "...";
        return [
            kbk.kbk_code.abp,
            kbk.kbk_code.prg,
            kbk.kbk_code.ppr ?? '000'
        ].map(part => String(part).padStart(3, '0')).join('.');
    }

    kbkFromProject(budget_level: string, funding_source: string): string {
        let regionKey = this.regionFilter;
        if (!this.regionFilter.endsWith("0101") && ["01", "02"].includes(budget_level)) {
            const regionPrefix = this.regionFilter.slice(0, -4);
            const replacementRegion = this.regionList.find(region =>
                region.code.startsWith(regionPrefix) && region.code.endsWith("0101")
            );
            if (replacementRegion) {
                regionKey = replacementRegion.code;
            }
        }
        const kbkObject = this.findKbkObject(budget_level, funding_source, regionKey);
        if (!kbkObject) return "...";  // Проверяем null перед передачей в kbkToString
        return this.kbkToString(kbkObject);
    }

    async downloadGenRep() {
        const params = {
            lang: this.$i18n.locale,
            region: this.regionFilter,
            cur_year: this.cur_year,
            transfer_group: this.transferGroupFilter
        }
        Ax(
            {
                url: '/api-py/transfert_loan_distr_rep' + '/' + JSON.stringify(params),
                method: 'POST',
                data: null,
                responseType: 'blob'
            },
            (data: any) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', (this.$t('modules.transfert.transfert_loan_distribution') as string) + ' ' + this.regionDisplayName(this.getRegion(this.regionFilter)) + '.xls');
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    this.makeToast('danger', this.$t('modules.transfert.toasts.error_download_file') as string, error.toString());
                }
            );
    }

    infoCostForm() {
        const isKk = this.$i18n.locale === 'kk';
        const info_id = isKk ? 44 : 42;
        const fileName = isKk ? 'Нұсқаулық_Трансферттер.pdf' : 'Инструкция_Трансферты.pdf';
        Ax(
            {
                url: '/api-py/get-info/' + info_id, //  Тело файла
                method: 'POST',
                data: null,
                responseType: 'blob'
            },
            (data: any) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            },
            (error) => {
                this.makeToast('danger', this.$t('modules.transfert.toasts.error_download_file') as string, error.toString());
            }
        );
    }
}
